export function isHtmlContent(content) {
  return /<[a-z][\s\S]*>/i.test(content || '');
}

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function isLegacyHeading(text, index) {
  return index > 0 && text.length < 80 && !text.endsWith('.') && !text.endsWith('?');
}

export function legacyContentToHtml(content) {
  const sections = content.split('||').map((part) => part.trim()).filter(Boolean);
  if (sections.length === 0) {
    return '';
  }

  return sections
    .map((section, index) => {
      if (isLegacyHeading(section, index)) {
        return `<h2>${escapeHtml(section)}</h2>`;
      }
      return `<p>${escapeHtml(section)}</p>`;
    })
    .join('');
}

export function prepareContentForEditor(content) {
  if (!content) {
    return '';
  }

  if (content.includes('||')) {
    const plainText = content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();

    if (plainText.includes('||')) {
      return legacyContentToHtml(plainText);
    }
  }

  if (isHtmlContent(content)) {
    return content;
  }

  return legacyContentToHtml(content);
}

export function legacyContentToSections(content) {
  return content.split('||').map((part) => part.trim()).filter(Boolean);
}

function htmlContentToBlocks(html) {
  const blocks = [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.body.childNodes.forEach((node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const tag = node.tagName.toLowerCase();
    const text = node.textContent?.trim() || '';
    if (!text) {
      return;
    }

    if (/^h[1-6]$/.test(tag)) {
      blocks.push({ type: 'heading', text });
      return;
    }

    if (tag === 'p') {
      blocks.push({ type: 'paragraph', text });
      return;
    }

    if (tag === 'blockquote') {
      blocks.push({ type: 'paragraph', text });
      return;
    }

    if (tag === 'ul' || tag === 'ol') {
      node.querySelectorAll('li').forEach((item) => {
        const itemText = item.textContent?.trim();
        if (itemText) {
          blocks.push({ type: 'paragraph', text: itemText });
        }
      });
    }
  });

  return blocks;
}

export function contentToBlocks(content) {
  if (!content) {
    return [];
  }

  if (isHtmlContent(content)) {
    return htmlContentToBlocks(content);
  }

  return legacyContentToSections(content).map((text, index) => ({
    type: isLegacyHeading(text, index) ? 'heading' : 'paragraph',
    text,
  }));
}
